import React from 'react';
import ImageItem from './ImageItem';
import { DropTarget } from 'react-dnd';

const imageTarget = {
  drop() {},
};

function collectTarget(connect) {
  return {
    connectDropTarget: connect.dropTarget(),
  };
}

const ImagesWrapper = ({
  imagePreviewUrls, connectDropTarget, onDeselectImage, onMoveImage, findImage,
}) => connectDropTarget(
  <div>
    {imagePreviewUrls.map(previewUrl =>
      <ImageItem
        key={previewUrl.key}
        id={previewUrl.key}
        onMoveImage={onMoveImage}
        findImage={findImage}
        previewUrl={previewUrl}
        onDeselectImage={onDeselectImage}
      />,
    )}
  </div>,
);

ImagesWrapper.propTypes = {
  connectDropTarget: React.PropTypes.func.isRequired,
  imagePreviewUrls: React.PropTypes.array.isRequired,
  onDeselectImage: React.PropTypes.func.isRequired,
  onMoveImage: React.PropTypes.func.isRequired,
  findImage: React.PropTypes.func.isRequired,
};

export default DropTarget('image', imageTarget, collectTarget)(ImagesWrapper);



// WEBPACK FOOTER //
// ./src/browser/steps/ImagesStep/ImagesWrapper.js